import { SettingsActionConstants } from "../action-constants";
import EmptyState from "../store/emptyState";
import globalReducerHelper from "./globalReducerHelper";

const Type = {
  General: "general",
  Odds: "odds",
  Language: "language",
  Country: "country",
  Appearance: "appearance"
};

const computeState = (type, state, newState) => {
  const typeState = {
    [type]: Object.assign({}, state[type], newState)
  };

  return Object.assign({}, state, typeState);
};

const settings = (state = EmptyState.settings, action) => {
  if (!state) return {};

  const { type, payload } = action;

  switch (action.type) {
    case SettingsActionConstants.GENERAL.TOGGLE_DRAWER: {
      return computeState(Type.General, state, {
        isDrawerActive: !state.general.isDrawerActive
      });
    }

    case SettingsActionConstants.GENERAL.SET_DRAWER_LOADED: {
      return computeState(Type.General, state, {
        isDrawerLoaded: payload
      });
    }

    case SettingsActionConstants.ODDS.SET_CURRENT: {
      return computeState(Type.Odds, state, {
        current: payload
      });
    }

    case SettingsActionConstants.APPEARANCE.SET_CURRENT: {
      return computeState(Type.Appearance, state, {
        current: payload
      });
    }

    case SettingsActionConstants.LANGUAGE.SET_TITLE: {
      return computeState(Type.Language, state, {
        title: payload
      });
    }

    case SettingsActionConstants.LANGUAGE.SET_CURRENT: {
      return computeState(Type.Language, state, {
        current: payload
      });
    }

    case SettingsActionConstants.LANGUAGE.SET_SETTINGS: {
      return computeState(Type.Language, state, {
        settings: payload
      });
    }

    case SettingsActionConstants.COUNTRY.SET_TITLE: {
      return computeState(Type.Country, state, {
        title: payload
      });
    }

    case SettingsActionConstants.COUNTRY.SET_SETTINGS: {
      return computeState(Type.Country, state, {
        settings: payload
      });
    }

    default:
      return globalReducerHelper(
        state,
        type,
        payload && payload.settings,
        EmptyState.settings
      );
  }
};

export default settings;
